import { defineStore } from 'pinia'
import { api } from '@/plugins/api'
import axios from 'axios'
import { authStore } from '@/stores/auth'
import { opportunityStore } from '@/stores/opportunity'
const apiUrl = window.config ? window.config.apiUrl : ''

export const fileStore = defineStore({
  id: 'file',
  state: () => ({
    fileData: [],
    file: null
  }),
  actions: {
    async getFiles(data) {
      let response = await api.get(`dashboard/clientFilesWithScans?firm=${data.firm}&vin=${data.vin}&folder=${data.folder}&id=${data.id}`)
      if (response) {
        if (response !== '') {
          this.fileData[data.folder] = response
        }
      }
    },
    async getFile(url) {
      let response = await api.get(url)
      return response
    },
    async deleteFile(data) {
      let filename = data.filename.replace(data.folder + '/', '')
      await api.delete(`data/removeFile?folder=${data.folder}&filename=${encodeURIComponent(filename)}&id=${data.id}`)
    },
    async uploadFile(data) {
      const CancelToken = axios.CancelToken
      const source = CancelToken.source()
      const saveFilesUrl = `${apiUrl}/data/uploadFiles`
      const { token } = authStore()

      // Build a multipart/form-data body so the backend binds to List<IFormFile> files.
      // The filename (3rd arg) is required — the API reads it from file.ContentDisposition.
      const formData = new FormData()
      formData.append('files', data.blob, data.filename)
      formData.append('folder', data.folder)
      formData.append('vin', data.vin ?? '')
      formData.append('firm', data.firm ?? '')
      formData.append('id', data.id ?? '')
      formData.append('name', data.filename ?? '')

      try {
        // Let axios set Content-Type (incl. the multipart boundary) from the FormData.
        await axios({
          method: 'post',
          url: saveFilesUrl,
          data: formData,
          cancelToken: source.token,
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
        // refresh the file list and push completion data back to the ADAS Map
        opportunityStore().pushToAdasMap(data.id)
        await this.getFiles({
          firm: data.firm,
          folder: data.folder,
          vin: data.vin,
          id: data.id
        })
      } catch (thrown) {
        // best-effort upload: log but don't abort the caller's flow
        if (axios.isCancel(thrown)) {
          console.log('Request canceled', thrown.message)
        } else {
          console.log(thrown)
        }
      }
    }
  }
})
